import React from "react";

import "./GamesListSection.scss";
import Skeleton from "../../../Skeleton/Skeleton";
import SkeletonList from "../../../SkeletonList/SkeletonList";
import { ThemeVariant } from "../../../../utils/constants/generic-types";

const SKELETON_SHIMMER_STYLE = { background: "#1b0c3dff" };
const SKELETON_BG_STYLE = { background: "rgba(51, 23, 120, 0.1)" };

function GamesListLoadingSkeleton() {
  return (
    <section className="games-list-section games-list-section-loading px-3">
      <Skeleton
        className="games-list-heading-skeleton"
        width={128}
        height={18}
        borderRadius={4}
        shimmerStyle={SKELETON_SHIMMER_STYLE}
        style={SKELETON_BG_STYLE}
        theme={ThemeVariant.DARK}
      />
      <div className="games-list-container games-list-skeleton-container">
        <SkeletonList noOfItems={4}>
          <div className="games-list-skeleton-item">
            <Skeleton
              width={110}
              height={110}
              borderRadius={8}
              shimmerStyle={SKELETON_SHIMMER_STYLE}
              style={SKELETON_BG_STYLE}
              theme={ThemeVariant.DARK}
            />
            <Skeleton
              className="games-list-title-skeleton"
              width={83}
              height={11}
              borderRadius={4}
              shimmerStyle={SKELETON_SHIMMER_STYLE}
              style={SKELETON_BG_STYLE}
              theme={ThemeVariant.DARK}
            />
            <Skeleton
              width={30}
              height={11}
              borderRadius={4}
              shimmerStyle={SKELETON_SHIMMER_STYLE}
              style={SKELETON_BG_STYLE}
              theme={ThemeVariant.DARK}
            />
          </div>
        </SkeletonList>
      </div>
    </section>
  );
}

export default GamesListLoadingSkeleton;
